export const VERSION = '11.0.0-rc.2.26504.105';
//# sourceMappingURL=pkg-version.js.map